import { render } from "./OrderPayPage.vue?vue&type=template&id=de2e259a&scoped=true"
import script from "./OrderPayPage.vue?vue&type=script&lang=js"
export * from "./OrderPayPage.vue?vue&type=script&lang=js"

import "./OrderPayPage.vue?vue&type=style&index=0&id=de2e259a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de2e259a"]])

export default __exports__